/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} RegionsInputs */

const en_regions = /** @type {(inputs: RegionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regions`)
};

const es_regions = /** @type {(inputs: RegionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regiones`)
};

/**
* | output |
* | --- |
* | "Regions" |
*
* @param {RegionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const regions = /** @type {((inputs?: RegionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<RegionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_regions(inputs)
	return es_regions(inputs)
});